export const MEAL_SPICY_LEVELS = [
  { value: 0, label: 'Łagodna' },
  { value: 10, label: 'Średnia' },
  { value: 20, label: 'Ostra' },
  { value: 30, label: 'Extra ostra' },
];
